import moment from 'moment';
import React, { useMemo } from 'react';
import { upperFirst } from 'lodash';
import { Button } from 'react-bootstrap';
import { FaEdit } from 'react-icons/fa';


export const useSysExaminationType = ({ t, general, cvs, rs, cns, pa, ent }) => {
	return useMemo(() => [
		{ value: 'general', label: t('EXAMINATIONS.NAV.GENERAL'), options: general },
		{ value: 'cvs', label: t('EXAMINATIONS.NAV.CVS'), options: cvs },
		{ value: 'rs', label: t('EXAMINATIONS.NAV.RS'), options: rs },
		{ value: 'cns', label: t('EXAMINATIONS.NAV.CNS'), options: cns },
		{ value: 'pa', label: t('EXAMINATIONS.NAV.PA'), options: pa },
		{ value: 'ent', label: t('EXAMINATIONS.NAV.ENT'), options: ent },
	], [t, general, cvs, rs, cns, pa, ent]);
};

export const useExaminationColumn = ({ t, currentPage, perPage, handleEdit }) => {
	return useMemo(() => [
		{
			name: '#',
			selector: (_, index) => (currentPage - 1) * perPage + index + 1,
			maxWidth: '55px',
			minWidth: '55px',
			center: true,
		},
		{
			name: t('EXAMINATIONS.TABLE.NAME'),
			selector: row => row.name,
			wrap: true,
			sortable: true,
			sortField: 'name',
		},
		{
			name: t('MEDICIENS.TABLE.STATUS'),
			cell: row => (
				<span className={row.status === 'inactive' ? 'text-danger' : 'text-success'}>
					{upperFirst(row.status)}
				</span>
			),
			wrap: true,
			sortable: true,
			sortField: 'status',
		},
		{
			name: t('EXAMINATIONS.TABLE.DATE'),
			selector: row => moment(row.created_at).format('DD-MM-YYYY'),
			wrap: true,
			sortable: true,
			sortField: 'created_at',
		},
		{
			cell: (row) => (
				<Button variant="warning" size="sm" onClick={() => handleEdit(row.id)}>
					<FaEdit style={{ color: 'white' }} />
				</Button>
			),
			button: true,
			minWidth: '70px',
			grow: 0
		}
	], [t, currentPage, perPage, handleEdit]);
};
